export default "__VITE_ASSET__07d75760__"